import http from "@core/fetch";
import { useData } from "@hooks/useData";
import { ISocialPost, SocialPosts } from "@models/SocialPosts";
import { ID } from "@datassential/platform-ui-lib";
import { v4 as uuid } from "uuid";
import apiConfig from "@apiConfig";

export interface KeywordPost {
    postId: string | null;
    text: string | null;
    publishedDate: string | null;
    engagementCount: number | null;
    url: string | null;
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get posts by keyword and lr category';

export function mapPost(post: KeywordPost): ISocialPost {
    return {
        id: post.postId || uuid(),
        source: SocialPosts.getPostSource(post.url ?? ''),
        sentiment: 'neutral',
        text: post.text ?? '',
        date: post.publishedDate ?? '',
        engagement: post.engagementCount ?? 0,
        url: post.url ?? '',
    };
}

export function mapPosts(posts: KeywordPost[]): ISocialPost[] {
    return (posts ?? []).map(mapPost);
}

async function getPostsByKeywordAndLrCategory(
    keywordId: number | null,
    lrCategoryId: ID,
): Promise<ISocialPost[]> {
    if (keywordId == null) return [];

    try {
        const response: KeywordPost[] = await http.get(REQUEST_TYPE, {
            keyword_id: keywordId,
            lr_category_id: lrCategoryId,
        });

        return mapPosts(response);
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);

        return [];
    }
}

export function usePostsByKeywordAndLrCategory(keywordId: number | null, lrCategoryId: ID) {
    return useData<ISocialPost[]>([], getPostsByKeywordAndLrCategory, keywordId, lrCategoryId);
}
